module.exports = function(string, length) {
  if (string.length <= length) {
    return string;
  }
  return string.substring(0, length) + '…';
};



// WEBPACK FOOTER //
// ./webroot/js/hbs_helpers/truncate.js